import { usePricingContentContext } from '@/components/wpl/pricing/src/pricing-content-context.tsx';
import { PricingFaq, FaqSectionProps } from '@/components/wpl/pricing/src/pricing-faq/pricing-faq';
import { PricingPageLayout } from '@/components/wpl/pricing/src/pricing-page-layout/pricing-page-layout';
import { wacToken } from '@/libraries/design/foundations';
import { ParentScrollTracking } from '@/utils/scroll-tracking/parent-scroll-tracker';

import { NonProfitPricingCalculator } from './pricing-calculator/non-profit-pricing-calculator.tsx';
import { Banner } from './sections/banner.tsx';
import { EligibleSection } from './sections/eligible-section.tsx';
import { EnterpriseSection } from './sections/enterprise-section.tsx';
import { Fineprint } from './sections/fineprint.tsx';
import { Hero } from './sections/hero.tsx';
import { NonprofitCalculatorHeading } from './sections/nonprofit-calculator-heading.tsx';
import { NonprofitNav } from './sections/nonprofit-nav.tsx';
import { OfficialSection } from './sections/official-section.tsx';
import { ResourcesSection } from './sections/resources-section.tsx';

export const NonProfitPricingPageTemplateWithTwc = () => {
	const content = usePricingContentContext();

	return (
		<>
			<ParentScrollTracking pageId="nonprofit-pricing-page">
				<PricingPageLayout
					nav={<NonprofitNav />}
					banner={<Banner />}
					hero={<Hero />}
					hasGlobalFooter={false}
				/>
				<PricingPageLayout bgColor={wacToken('color.neutral.light100')} hasGlobalFooter={false}>
					<ParentScrollTracking>
						<EligibleSection />
					</ParentScrollTracking>
				</PricingPageLayout>
				<PricingPageLayout hasGlobalFooter={false}>
					<ParentScrollTracking>
						<NonprofitCalculatorHeading />
						<NonProfitPricingCalculator />
						<EnterpriseSection />
					</ParentScrollTracking>
				</PricingPageLayout>
				<PricingPageLayout bgColor={wacToken('color.extended.blue100')} hasGlobalFooter={false}>
					<ParentScrollTracking>
						<OfficialSection />
					</ParentScrollTracking>
				</PricingPageLayout>
				<PricingPageLayout hasGlobalFooter={false}>
					<ParentScrollTracking>
						<ResourcesSection />
					</ParentScrollTracking>
				</PricingPageLayout>
				<PricingPageLayout hasGlobalFooter={true}>
					<ParentScrollTracking>
						<PricingFaq
							header={content?.getMoreDetailsTitle as FaqSectionProps['header']}
							planDetails={content?.additionalDetails as FaqSectionProps['planDetails']}
						/>
						<Fineprint />
					</ParentScrollTracking>
				</PricingPageLayout>
			</ParentScrollTracking>
		</>
	);
};
